// extracted by mini-css-extract-plugin
export default {"reportRoot":"ViewReport_reportRoot__rOJHf","reportOverlay":"ViewReport_reportOverlay__BGqcm"};